/* eslint-disable indent */
import React from "react";

import isEqual from "lodash/isEqual";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { FiCheck } from "react-icons/fi";
import { NAME_SPACES } from "shared/locals/constants";
import "./styles.scss";

const List = ({ data, onClick, checkedItem, setCheckedItem, hideCheck }) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS, {
    keyPrefix: "LIST_PRODUCT_FOLDER",
  });

  return (
    <div
      className={`product--card ${
        !hideCheck && isEqual(checkedItem, data) ? "active--product" : ""
      }`}
      onClick={() => {
        setCheckedItem(data);
        onClick(data);
      }}>
      <div className={"product--card--wrap"}>
        <div className={"product--card--wrap--left"}>
          <img src={data.productPhoto} />
        </div>
        <div className={"product--card--wrap--right"}>
          <h2 className={"text--16"}>N° {data.folderNum}</h2>
          <h3 className={"text--14"}>
            {data.productDesc} - {data.productBrand}
          </h3>
          <p className={"text--10"}>
            {`${
              data.receiptNo
                ? t("INVOICE_NUM", { receiptNo: data.receiptNo })
                : ""
            } ${
              data.purchaseDate
                ? t("DATE", {
                    purchaseDate: moment(data.purchaseDate).format("DD.MM.YY"),
                  })
                : ""
            }`}
          </p>
        </div>
      </div>
      {!hideCheck && isEqual(checkedItem, data) && (
        <div className={"product--card--icon"}>
          <FiCheck size={28} color={"#48E4BE"} />
        </div>
      )}
    </div>
  );
};

List.propTypes = {
  data: PropTypes.shape({
    productPhoto: PropTypes.string,
    folderNum: PropTypes.string,
    productDesc: PropTypes.string,
    productBrand: PropTypes.string,
    purchaseDate: PropTypes.string,
    creationDate: PropTypes.string,
    receiptNo: PropTypes.string,
  }),
  checkedItem: PropTypes.shape({
    productPhoto: PropTypes.string,
    folderNum: PropTypes.string,
    productDesc: PropTypes.string,
    productBrand: PropTypes.string,
    purchaseDate: PropTypes.string,
    creationDate: PropTypes.string,
    receiptNo: PropTypes.string,
  }),
  onClick: PropTypes.func,
  hideCheck: PropTypes.bool,
  setCheckedItem: PropTypes.func,
};

List.defaultProps = {
  onClick: () => {},
};

export default List;
